import { render, staticRenderFns } from "./Arm400-B.vue?vue&type=template&id=816375a0"
import script from "./Arm400-B.vue?vue&type=script&lang=js"
export * from "./Arm400-B.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports